import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

const ShareGlyph = ({ c = '#8ab4ff' }: { c?: string }) => (
  <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ verticalAlign: '-3px', margin: '0 3px' }}>
    <path d="M12 3v13" /><path d="m8 7 4-4 4 4" /><path d="M4 12v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7" />
  </svg>
);
const HomeGlyph = ({ c = '#8ab4ff' }: { c?: string }) => (
  <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ verticalAlign: '-3px', margin: '0 3px' }}>
    <rect x="3" y="3" width="18" height="18" rx="4" /><path d="M12 8v8M8 12h8" />
  </svg>
);

// The iOS "Add to Home Screen" bottom sheet. A one-tap Web Share button (opens the system
// sheet directly) with a primed hint, plus the manual steps as the reliable fallback.
export function IosInstallSheet({ onClose, canWebShare, openShareSheet }: { onClose: () => void; canWebShare: boolean; openShareSheet: () => void }) {
  const { t } = useTranslation('common');
  return createPortal(
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 2100 }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ background: '#161a24', borderTop: '1px solid rgba(74,158,255,0.3)', borderRadius: '16px 16px 0 0', padding: '20px 20px calc(28px + env(safe-area-inset-bottom))', width: '100%', maxWidth: 480, color: 'var(--text)' }}>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>{t('install.iosTitle', { defaultValue: 'Установка на iPhone' })}</div>

        {canWebShare && (
          <>
            <button type="button" onClick={openShareSheet}
              style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '11px', borderRadius: 10, border: 'none', background: 'var(--primary)', color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>
              <ShareGlyph c="currentColor" />{t('install.iosShareBtn', { defaultValue: 'Открыть меню «Поделиться»' })}
            </button>
            <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.5, margin: '10px 2px 0' }}>
              {t('install.iosThenPick', { defaultValue: 'Затем выберите «На экран «Домой»' })}<HomeGlyph />{t('install.iosScrollHint', { defaultValue: '(прокрутите вниз)' })}
            </div>
            <div style={{ fontSize: 12, color: 'var(--dim)', textTransform: 'uppercase', letterSpacing: 0.4, margin: '16px 0 8px' }}>{t('install.iosManual', { defaultValue: 'или вручную' })}</div>
          </>
        )}

        <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9, color: 'var(--muted)', fontSize: 14 }}>
          <li>{t('install.iosStep1', { defaultValue: 'Нажмите «Поделиться» внизу Safari' })}<ShareGlyph /></li>
          <li>{t('install.iosStep2', { defaultValue: 'Прокрутите вниз, пункт «На экран «Домой»' })}<HomeGlyph /></li>
          <li>{t('install.iosStep3', { defaultValue: 'Нажмите «Добавить» — готово.' })}</li>
        </ol>
        <button type="button" onClick={onClose}
          style={{ marginTop: 18, width: '100%', padding: '11px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.15)', background: 'transparent', color: 'var(--text-2)', fontWeight: 600, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>
          {t('install.close', { defaultValue: 'Понятно' })}
        </button>
      </div>
    </div>,
    document.body,
  );
}
